import { render, staticRenderFns } from "./appchart.vue?vue&type=template&id=1da627d9&"
import script from "./appchart.vue?vue&type=script&lang=js&"
export * from "./appchart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports